export default {
    initSdk: function () {
        /* eslint-disable */
        window.fbAsyncInit = function () {
            FB.init({
                appId: '184348308833280',
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v5.0'
            });
        };
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
        /* eslint-enable */
    },

    shareFacebook: function (options) {
        options.method = options.method || 'share'
        options.display = options.display || 'touch'
        if (window.FB && window.FB.ui) {
            window.FB.ui(options)
        }
    }
}
